import React from 'react';

export const useFormSubmit = (formId: string) => {
  return React.useCallback(() => {
    const form = document.getElementById(formId);
    if (form) {
      form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    }
  }, [formId]);
};
